//概况
export const index_right_list = [
    {
        src: require('@/assets/icon/new_icon_03.jpg'),
        title: '品牌官网',
        subheading: '轻松拥有公司网站',
        url: '/buildPlatform/webManagement/chineseStation',
        btn: '前往管理',
        type: 'router',//router是站内，web是站外
        id: 7
    },
    // {
    //     src:require('@/assets/icon/new_icon_05.jpg'),
    //     title:'外文站',
    //     subheading:'一键制作专属英文站',
    //     url:'/buildPlatform/webManagement/foreign',
    //     btn:'免费开通',
    //     type:'router',
    //     id: 1
    // },
    {
        src: require('@/assets/icon/index_icon_05.jpg'),
        title: 'H5制作',
        subheading: '随时可制作H5',
        url: 'https://www.baidu.com/',
        btn: '立即制作',
        type: 'web',
        id: 9
    },
    {
        src: require('@/assets/icon/index_icon_03.jpg'),
        title: '智能店铺',
        subheading: '轻松搞定多个店铺',
        url: '/buildPlatform/webManagement/smartShop',
        btn: '开通',
        type: 'router',
        id: 8
    },
    // {
    //     src: require('@/assets/icon/index_icon_07.jpg'),
    //     title: '小程序',
    //     subheading: '分分钟拥有小程序',
    //     url: 'http://xcx.71360.com/',
    //     btn: '开通',
    //     type: 'router',
    //     id: 10
    // },
    // {
    //     src:require('@/assets/icon/new_icon_07.jpg'),
    //     title:'内容管理',
    //     subheading:'统一管理品牌官网内容',
    //     url:'/buildPlatform/contentManagement/productManagement',
    //     btn:'前往管理',
    //     type:'router',
    //     id: 2
    // },
    {
        src: require('@/assets/icon/index_icon_09.jpg'),
        title: '流量统计',
        subheading: '实时监测网站数据',
        url: '/seeResult/flowStatistics',
        btn: '查看',
        type: 'router',
        id: 3
    }
]


//行业定位数据
export const industryPosition = [
    {
        title:'网站类型？',
        key:'theme_custom',//配置最后的结果绑定在result下那个key
        radio:[
            {
                text:'企业',
                label:'1',//根据后台的字段定
            },
            {
                text:'个人',
                label:'2',
            }
        ]

    },
    {
        title:'使用网站的侧重点？',
        key:'theme_emphasis',
        radio:[
            {
                text:'产品展示',
                label:'1',
            },
            {
                text:'企业形象',
                label:'2',
            }
        ]

    },
    {
        title:'你公司的产品种类？',
        key:'theme_attr',
        radio:[
            {
                text:'丰富',
                label:'1',
            },
            {
                text:'简单',
                label:'2',
            }
        ]
    },
    /*{
        title:'喜欢的网页类型？',
        key:'',
        radio:[
            {
                text:'响应式',
                label:'',
            },
            {
                text:'营销式',
                label:'',
            }
        ]
    },*/
    {
        title:'喜欢的网站风格？',
        key:'theme_style',
        radio:[
            {
                text:'简约',
                label:'1',
            },
            {
                text:'清新',
                label:'2',
            },
            {
                text:'古典',
                label:'3',
            },
        ]
    },
    {
        title:'喜欢的屏幕？',
        key:'theme_screen',
        radio:[
            {
                text:'宽屏',
                label:'2',
            },
            {
                text:'窄屏',
                label:'1',
            }
        ]
    },
    /*{
        title:'企业喜欢的颜色？',
        key:'',
        radio:[
            {
                text:'红色',
                label:'',
            },
            {
                text:'橙色',
                label:'',
            },
            {
                text:'黄色',
                label:'',
            },
            {
                text:'绿色',
                label:'',
            },
            {
                text:'青色',
                label:'',
            },
            {
                text:'蓝色',
                label:'',
            },
            {
                text:'紫色',
                label:'',
            }

        ]
    },*/

]

let i_Obj = {industry:'选择所属行业'};
industryPosition.map((val)=>{
    i_Obj[val.key] = val.title.replace('？','')
})
//行业定位对象
export const industryObj = i_Obj;

//小程序详情，秒数转时分秒
export function formatSeconds(value) {
    var secondTime = parseInt(value);// 秒
    var minuteTime = 0;// 分
    var hourTime = 0;// 小时
    if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
       /* if(minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = parseInt(minuteTime / 60);
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = parseInt(minuteTime % 60);
        }*/
    }
    var result = "" + parseInt(secondTime) + "''";

    if(minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "'" + result;
    }
    /*if(hourTime > 0) {
        result = "" + parseInt(hourTime) + "h" + result;
    }*/
    return result;
}
/*判断该时间戳是否为近七天的数据*/
export function isNearlySevenDays(number) {
    let result = false
    // 当天
    const date1 = new Date();
    // 前六天
    const date7 = new Date(date1.getTime() - 168*60*60*1000);
    if(number >= date7 && number <= date1){
        result = true
    }
    return result
}

// 新建品牌官网新手指导步骤
export const buildChineseWebsiteSteps = [
    {
        curStep: 0,
        title:'有老司机带着你，建个网站so easy!!',
        content: '点击品牌官网',
        lastStep: {},
        nextStep: {
            url: '/buildPlatform/industryPosition' // 下一步选择行业
        },
        placementStyle: 'right-start',
        popperClass: 'open_websit',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 1,
        title:'行业定位更加精准为您推荐适合的模板',
        content: '',
        lastStep: {
            url: '/buildPlatform/webManagement/chineseStation', // 上一步品牌官网
            query: {
                type:'skip',
                ProductRecordID: ''
            }
        },
        nextStep: {
            url: '/buildPlatform/selectTemplate', // 下一步选择模板
            query: {
                industry: 9,
                theme_custom: 1,
                theme_emphasis: 1,
                theme_attr: 1,
                theme_style: 1,
                theme_screen: 2,
                type:'recommend',
                ProductRecordID: ''
            }
        },
        placementStyle: 'top',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 2,
        title:'海量模板，总有几套适合您的,',
        content: '快选择自己喜欢的模板吧',
        lastStep: {
            url: '/buildPlatform/industryPosition', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '/buildPlatform/webManagement/chineseStation', // 下一步选择模板
            query: {}
        },
        placementStyle: 'top',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 3,
        title:'您的域名备案完成，并且内容已添加,',
        content: '点击上线即可通过域名访问网站',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'top',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 4,
        title:'确认您当前选择的模板样式风格，',
        content: '如不满意有10次更换模板机会',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 5,
        title:'使用可视化可把自己网站装修的更美哟！！',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 6,
        title:'对网站产品/案例/新闻等资料统一管理啦！！',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: false,
        },
        closeStepBtn: {
            closeStepBtnText: '知道了',
            closeStepIsShow: true,
            closeStepBtnStyle: 2 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 7,
        title:'PC官网，海量模板任您选，快速生成网站',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'left-start',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 8,
        title:'智能店铺为中小企业提供互联网转型产品应用市场',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 9,
        title:'微信H5页面,模板,短视频,场景应用的专业制作平台',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 10,
        title:'小程序网站，微信，百度，支付宝，头条多平台展示',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: false,
        },
        closeStepBtn: {
            closeStepBtnText: '我知道了',
            closeStepIsShow: true,
            closeStepBtnStyle: 2 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 11,
        title:'有老司机带着你，开通智能店铺so easy!!',
        content: '点击智能店铺',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'right-start',
        popperClass: 'open_smart_shop',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 12,
        title:'海量模板，总有几套适合您的,',
        content: '快选择自己喜欢的模板吧',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: 'select_templated',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 13,
        title:'到这里上传店铺的LOGO和Banner!',
        content: '离开店又进一步啦！',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: 'shop_set',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 14,
        title:'进行SEO设置，店铺可进行推广啦！',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: 'seo_set',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: false,
        },
        closeStepBtn: {
            closeStepBtnText: '我知道了',
            closeStepIsShow: true,
            closeStepBtnStyle: 2 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 15,
        title:'有老司机带着你，建个网站so easy!!',
        content: '点击外文站',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '/buildPlatform/foreignSelectTemplate', // 下一步选择模板
            query: {}
        },
        placementStyle: 'right-start',
        popperClass: 'open_foreign_websit',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 16,
        title:'海量模板，总有几套适合您的,',
        content: '快选择自己喜欢的模板吧',
        lastStep: {
            url: '/buildPlatform/webManagement/foreign', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '/buildPlatform/webManagement/foreign', // 下一步选择模板
            query: {}
        },
        placementStyle: 'top',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 17,
        title:'您的网站内容已添加，有可使用的域名，',
        content: '点击上线即可通过域名访问网站',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'top',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 18,
        title:'开通英文站后，还可申请其他语言哦，',
        content: '且一键生成即可',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'top',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 19,
        title:'对网站产品/案例/新闻等资料统一管理啦！！',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: true,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: true,
        },
        closeStepBtn: {
            closeStepBtnText: '跳过',
            closeStepIsShow: true,
            closeStepBtnStyle: 1 // 1： type="primary" plain  2: type="primary"
        },
    },
    {
        curStep: 20,
        title:'使用可视化可把自己网站装修的更美哟！！',
        content: '',
        lastStep: {
            url: '', // 上一步选择行业
            query: {}
        },
        nextStep: {
            url: '', // 下一步选择模板
            query: {}
        },
        placementStyle: 'bottom',
        popperClass: '',
        lastStepBtn: {
            lastStepBtnText: '上一步',
            lastStepIsShow: false,
        },
        nextStepBtn: {
            nextStepBtnText: '下一步',
            nextStepIsShow: false,
        },
        closeStepBtn: {
            closeStepBtnText: '知道了',
            closeStepIsShow: true,
            closeStepBtnStyle: 2 // 1： type="primary" plain  2: type="primary"
        }
    }
]
